module.exports = __webpack_public_path__ + "img/tool-toolbox.2796a3f1.svg";